import React from 'react';
import { Button } from '@core-ui/Components/ui/button.tsx';

interface FallbackProps {
  children?: React.ReactNode;
  icon: string;
  buttonText: string;
  message: string;
  redirectionUrl?: string
}

export function IntegrationsListsFallback ({
  icon,
  message,
  buttonText,
  redirectionUrl
}: FallbackProps): React.JSX.Element {
  
  return (
    <section className="grid justify-center p-2 bg-background rounded-md">
      <header className='flex justify-center'>
        <img className="w-13 h-13" src={icon} alt='integration-icon'></img>
      </header>
      <p className="text-center text-gray-500 text-md font-bolder py-4">{message}</p>
      <Button><a href={redirectionUrl ?? 'settings/app'}>{buttonText}</a></Button>
    </section>
  );
}